var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeLeftNavSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44.772427mm",
    height: "40.000004mm",
    viewBox: "0 0 44.772426 40.000004",
    id: "left-nav",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  })), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d2d2d",
      stroke: "#000000",
      strokeWidth: 0.0719098
    },
    id: "rect4",
    width: 44.686275,
    height: 0.048090216,
    x: 0.035954885,
    y: 13.622955
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d2d2d",
      stroke: "#000000",
      strokeWidth: 0.0719098
    },
    id: "rect4-5",
    width: 44.686275,
    height: 0.048090216,
    x: 0.035954975,
    y: 26.581953
  }), /*#__PURE__*/React.createElement("rect", {
    style: {
      fill: "#2d2d2d",
      stroke: "#000000",
      strokeWidth: 0.0812591
    },
    id: "rect4-30",
    width: 39.918743,
    height: 0.06874086,
    x: 0.040629551,
    y: -44.731796,
    transform: "rotate(90)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLeftNavSvg);
export default __webpack_public_path__ + "static/media/home_left_nav_svg.06f0b87e560a59f5afe0a54ede5ea5fa.svg";
export { ForwardRef as ReactComponent };